"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (variant) { return function (_a) {
    var theme = _a.theme, strong = _a.strong;
    return "font-weight: " + theme.fonts[variant].fontWeight[strong ? 1 : 0] + ";";
}; });
